import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import LandingPageHeader from '../header/LandingPageHeader';
import LandingPageFooter from '../footer/LandingPageFooter';
import RoutesMap from '../../route_control/RouteControl';

export default function PublicLayout() {

    const location = useLocation();
    const noLayoutPaths = [RoutesMap.TERMS_CONDITIONS_APP.path, RoutesMap.PRIVACY_POLICY_APP.path];

    const isSimplePage = noLayoutPaths.includes(location.pathname);

    return isSimplePage ? (
        <Outlet />
    ) : (
        <>
            <LandingPageHeader />
            <Outlet />
            <LandingPageFooter />
        </>
    );
}

